import React from 'react'

//Checkbox is the final structure which is rendered.
function Checkbox({item, handleCheckboxChange}) {
    return (
        <>
            {
                <li className="d-flex flex-row map-filter-list-item justify-content-start align-items-center">
                   <img style={{marginLeft: '5px'}} src={item.icon} width='30'/>
                    <label style={{textAlign: 'left', fontWeight: '500', fontFamily: 'Montserrat'}} htmlFor="earthquakes" className="map-filter-checkbox-label">{item.category} ({item.total})</label>
                    <input  name={item.category.split(' ').join('_').toLowerCase()} id={item.category.split(' ').join('_').toLowerCase()} value={item.category.split(' ').join('_').toLowerCase()} onChange={ handleCheckboxChange } checked={item.isChecked} type="checkbox" className="map-filter-checkbox"/>
                    <span  className="checkmark"></span>
                    
                </li>  
            }
        </>
    )
}

export default Checkbox
